import { Map, List } from 'immutable'

import unitService from '../services/unit'
import wopi360Service from '../services/wopi360'

const FETCH_UNIT = 'unit/FETCH_UNIT'
const FETCH_UNIT_SUCCESS = 'unit/FETCH_UNIT_SUCCESS'

const FETCH_UNIT_WOPI360_TARGETS = 'unit/FETCH_UNIT_WOPI360_TARGETS'
const FETCH_UNIT_WOPI360_TARGETS_SUCCESS = 'unit/FETCH_UNIT_WOPI360_TARGETS_SUCCESS'

const REMOVE_WOPI360_TARGET_FROM_UNIT = 'unit/REMOVE_WOPI360_TARGET_FROM_UNIT'
const REMOVE_WOPI360_TARGET_FROM_UNIT_SUCCESS = 'unit/REMOVE_WOPI360_TARGET_FROM_UNIT_SUCCESS'
const REMOVE_WOPI360_TARGET_FROM_UNIT_FAILURE = 'unit/REMOVE_WOPI360_TARGET_FROM_UNIT_FAILURE'

const UPDATE_UNIT_WOPI360_TARGET_RELATIONS = 'unit/UPDATE_UNIT_WOPI360_TARGET_RELATIONS'
const UPDATE_UNIT_WOPI360_TARGET_RELATIONS_SUCCESS =
  'unit/UPDATE_UNIT_WOPI360_TARGET_RELATIONS_SUCCESS'
const UPDATE_UNIT_WOPI360_TARGET_RELATIONS_FAILURE =
  'unit/UPDATE_UNIT_WOPI360_TARGET_RELATIONS_FAILURE'

const defaultState = Map({
  currentUnit: null,
  isLoading: false,
  wopi360Targets: null,
  wopi360TargetsPagination: null
})

export default function unitReducer(state = defaultState, action = undefined) {
  switch (action.type) {
    case FETCH_UNIT:
      return state.update('isLoading', () => true).update('currentUnit', () => null)

    case FETCH_UNIT_SUCCESS:
      return state.update('isLoading', () => false).update('currentUnit', () => action.payload)

    case FETCH_UNIT_WOPI360_TARGETS:
      return state
        .update('wopi360Targets', () => null)
        .update('wopi360TargetsPagination', () => null)

    case FETCH_UNIT_WOPI360_TARGETS_SUCCESS:
      return state
        .update('wopi360Targets', () => action.payload.targets)
        .update('wopi360TargetsPagination', () => action.payload.pagination)

    case REMOVE_WOPI360_TARGET_FROM_UNIT_SUCCESS:
      return state.update('wopi360Targets', targets =>
        targets.filter(target => target.uuid !== action.payload)
      )

    default:
      return state
  }
}

export function getUnit(uuid) {
  return dispatch => {
    dispatch({ type: FETCH_UNIT })

    return unitService
      .getUnit(uuid)
      .then(response => dispatch({ type: FETCH_UNIT_SUCCESS, payload: response.data }))
  }
}

export function getUnitWopi360Targets({ organisationId, unitUuid, page }) {
  return dispatch => {
    dispatch({ type: FETCH_UNIT_WOPI360_TARGETS })

    return wopi360Service
      .searchWopi360Targets({
        organisationId,
        unitUuid,
        filters: { status: 'all' },
        page: page || 1
      })
      .then(response =>
        dispatch({
          type: FETCH_UNIT_WOPI360_TARGETS_SUCCESS,
          payload: {
            targets: List(response.data.results),
            pagination: response.data.pagination
          }
        })
      )
  }
}

export function removeWopi360TargetFromUnit(unitUuid, wopi360TargetUuid) {
  return dispatch => {
    dispatch({ type: REMOVE_WOPI360_TARGET_FROM_UNIT })

    return unitService
      .removeWopi360TargetFromUnit(unitUuid, wopi360TargetUuid)
      .then(() =>
        dispatch({ type: REMOVE_WOPI360_TARGET_FROM_UNIT_SUCCESS, payload: wopi360TargetUuid })
      )
      .catch(e => dispatch({ type: REMOVE_WOPI360_TARGET_FROM_UNIT_FAILURE, payload: e }))
  }
}

export function updateUnitWopi360TargetRelations(unitUuid, targetUuids) {
  return dispatch => {
    dispatch({ type: UPDATE_UNIT_WOPI360_TARGET_RELATIONS })

    return unitService
      .updateUnitWopi360TargetRelations(unitUuid, targetUuids)
      .then(() => dispatch({ type: UPDATE_UNIT_WOPI360_TARGET_RELATIONS_SUCCESS }))
      .catch(e => dispatch({ type: UPDATE_UNIT_WOPI360_TARGET_RELATIONS_FAILURE, payload: e }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/unit.js